(function stactTrackingMain(window, document) {
  'use strict';
  if (window.stactLeadTrackingLoaded) return;
  window.stactLeadTrackingLoaded = true;
  var key = 'stact-pending-lead-v1';
  var origin = 'https://vinrum-konfigurator-neu.brangstrupholding.chatgpt.site';
  var formTypes = {
    ContactFormV12: 'kontakt', StactDesignerContact: 'designer', DoorQuoteForm: 'doer',
    SlidingQuoteForm: 'skydedoer', KitchenContactForm: 'koekken', RoomContactForm: 'vinrum',
    StationContactForm: 'vinstation'
  };
  function pending(type, formId) {
    // Store only form metadata, never customer details.
    var data = {type: type, formId: formId || '', path: window.location.pathname, createdAt: Date.now()};
    try { window.sessionStorage.setItem(key, JSON.stringify(data)); } catch (_) {}
  }
  function read() {
    try { return JSON.parse(window.sessionStorage.getItem(key)); } catch (_) { return null; }
  }
  function publish(type, newsletter) {
    var shopify = window.Shopify;
    if (shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
        if (!error && window.Shopify.customerPrivacy) publish(type, newsletter);
      });
      return;
    }
    if (!shopify || !shopify.customerPrivacy ||
        typeof shopify.customerPrivacy.analyticsProcessingAllowed !== 'function' ||
        !shopify.customerPrivacy.analyticsProcessingAllowed()) return;
    var data = {lead_type: type};
    if (shopify.analytics && typeof shopify.analytics.publish === 'function') {
      try { shopify.analytics.publish(newsletter ? 'stact:newsletter_submitted' : 'stact:lead_submitted', data); } catch (_) {}
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: newsletter ? 'stact_newsletter_submitted' : 'stact_lead_submitted', lead_type: type});
  }
  function init() {
    var newsletterRecorded = false;
    function onSubmit(event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM' || event.defaultPrevented || !form.checkValidity()) return;
      if (form.id === 'mc-embedded-subscribe-form') {
        var email = form.querySelector('input[type="email"]');
        if (!email || !email.value.trim() || !email.validity.valid) return;
        // Mailchimp confirms the subscription externally; this records the handoff only.
        if (!newsletterRecorded) { newsletterRecorded = true; publish('nyhedsbrev', true); }
        return;
      }
      if (form.id === 'stact-glass-contact') { pending('glas', form.id); return; }
      if (form.id === 'stact-vinrum-contact') return;
      var kind = form.querySelector('input[name="form_type"]');
      if (!kind || kind.value !== 'contact') return;
      var action;
      try { action = new URL(form.action, window.location.href); } catch (_) { return; }
      if (action.origin !== window.location.origin || !/\/contact\/?$/.test(action.pathname)) return;
      pending(formTypes[form.id] || 'kontakt', form.id);
    }
    Array.prototype.forEach.call(document.forms, function (form) {
      form.addEventListener('submit', onSubmit);
    });
    var frame = document.getElementById('stact-vinrum');
    if (frame) window.addEventListener('message', function (event) {
      if (event.origin !== origin || event.source !== frame.contentWindow || !event.data ||
          event.data.type !== 'stact-vinrum-submit') return;
      var d = event.data;
      if (typeof d.customer === 'string' && d.customer.trim() && d.customer.length <= 100 &&
          typeof d.email === 'string' && d.email.length <= 160 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email) &&
          typeof d.phone === 'string' && d.phone.trim() && d.phone.length <= 30 &&
          typeof d.project === 'string' && d.project.length > 0 && d.project.length <= 6000) pending('vinrum');
    });
    var params = new URLSearchParams(window.location.search);
    var path = window.location.pathname;
    var saved = read();
    var type = /\/pages\/vinkaelder\/?$/.test(path) && params.get('vinrum_sendt') === '1' ? 'vinrum' :
      /\/pages\/glas-til-vinrum\/?$/.test(path) && params.get('glas_sendt') === '1' ? 'glas' : null;
    // Shopify adds contact_posted=true only after accepting a contact form.
    if (!type && params.get('contact_posted') === 'true' && saved && saved.formId &&
        saved.path === path && (!window.location.hash || window.location.hash === '#' + saved.formId)) {
      type = saved.type;
    }
    if (type && saved && saved.type === type && (!saved.path || saved.path === path) &&
        Date.now() - saved.createdAt >= 0 && Date.now() - saved.createdAt < 30 * 60 * 1000) {
      try { window.sessionStorage.removeItem(key); } catch (_) {}
      publish(type);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(window, document);
